/**
 * @generated SignedSource<<0fa468c06abec4bbc9afa56d37e4cfcf>>
 * @relayHash 37e0a3718e84d2a27f837e87cccbcff8
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 37e0a3718e84d2a27f837e87cccbcff8

import { ConcreteRequest } from 'relay-runtime';
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
export type insureeDataFromSasisByHealthInsuranceCardNumberQuery$variables = {
  healthInsuranceCardNumber: string;
};
export type insureeDataFromSasisByHealthInsuranceCardNumberQuery$data = {
  readonly ch_insureeDataFromSasisByHealthInsuranceCardNumber: {
    readonly mapped: {
      readonly address: {
        readonly city: string;
        readonly countryCode: string;
        readonly houseNumberStreet: string;
        readonly postalCode: string;
      };
      readonly dateOfBirth: any;
      readonly firstName: string;
      readonly gatekeeperZsr: string | null;
      readonly gender: Gender;
      readonly healthInsurance: string;
      readonly insuranceCardNumber: string;
      readonly insureeNumber: string;
      readonly isPrimary: boolean;
      readonly lastName: string;
      readonly nationalInsuranceNumber: number;
      readonly socialSecurityNumber: string | null;
      readonly validFrom: any;
      readonly validTo: any;
    } | null;
    readonly rawXml: string | null;
    readonly returnCode: string | null;
    readonly returnMessage: string | null;
  };
};
export type insureeDataFromSasisByHealthInsuranceCardNumberQuery = {
  response: insureeDataFromSasisByHealthInsuranceCardNumberQuery$data;
  variables: insureeDataFromSasisByHealthInsuranceCardNumberQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "healthInsuranceCardNumber"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "healthInsuranceCardNumber",
        "variableName": "healthInsuranceCardNumber"
      }
    ],
    "concreteType": "SasisLookupResult",
    "kind": "LinkedField",
    "name": "ch_insureeDataFromSasisByHealthInsuranceCardNumber",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "PatientInsuranceCardDetails",
        "kind": "LinkedField",
        "name": "mapped",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "firstName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "lastName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "dateOfBirth",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gender",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insureeNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "insuranceCardNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "socialSecurityNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "healthInsurance",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "nationalInsuranceNumber",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isPrimary",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "gatekeeperZsr",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validFrom",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "validTo",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Address",
            "kind": "LinkedField",
            "name": "address",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "houseNumberStreet",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "city",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "postalCode",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "countryCode",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "rawXml",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnCode",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "returnMessage",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "insureeDataFromSasisByHealthInsuranceCardNumberQuery",
    "selections": (v1/*:: as any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "insureeDataFromSasisByHealthInsuranceCardNumberQuery",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "37e0a3718e84d2a27f837e87cccbcff8",
    "metadata": {},
    "name": "insureeDataFromSasisByHealthInsuranceCardNumberQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f031f908075ed38f0cac358bcd20f6fe";

export default node;
